export default function PointerGroup() {
  return (
    <group>
      <pointLight
        intensity={2}
        name='forArea1'
        color={'#F39D1C'}
        decay={1}
        position={[0.7, 0.15, 0.3]}
        distance={0.2}
      />
      <pointLight
        intensity={2}
        name='forPick2'
        color={'#1C55F3'}
        decay={1}
        position={[0.1, 0.15, 0.4]}
        distance={0.2}
      />
      <pointLight
        name='forPick1'
        intensity={2}
        color={'#4162F3'}
        decay={4}
        position={[0.53, 0.2, 0.32]}
        distance={0.3}
      />
      <pointLight
        name='forPick1'
        intensity={2}
        color={'#4162F3'}
        decay={4}
        position={[0.43, 0.2, 0.22]}
        distance={0.4}
      />
      <pointLight
        name='forPick1'
        intensity={2}
        color={'#4162F3'}
        decay={4}
        position={[0.6, 0.2, 0.27]}
        distance={0.3}
      />
      <pointLight
        intensity={2}
        name='forArea3'
        color={'#F38F1C'}
        decay={1}
        position={[0.02, 0.15, 0.6]}
        distance={0.3}
      />
      <pointLight
        intensity={2}
        name='forArea3'
        color={'#F38F1C'}
        decay={1}
        position={[0.02, 0.15, 0.8]}
        distance={0.3}
      />
      <pointLight
        intensity={2}
        name='forPick2'
        color={'#4162F3'}
        decay={1}
        position={[0.02, 0.15, 0.3]}
        distance={0.5}
      />
      <pointLight
        intensity={2}
        name='forArea4'
        color={'#46CC5D'}
        decay={1}
        position={[-0.4, 0.15, 0.6]}
        distance={0.3}
      />
    </group>
  );
}
